import { forwardRef, useState, Fragment } from 'react'
import suggestionData from '../../helpers/suggestion-data'

const Triangle = (
  <svg xmlns='http://www.w3.org/2000/svg' data-name='Triangle' viewBox='0 0 19.8 12' height='12'>
    <defs />
    <path
      fill='#b9b9b9'
      d='M9.9 0L6.7 3.6.5 10.4 0 11h1.4l.4-.5 5.3-5.9 2.8-3.1 8.6 9.5h1.3L9.9 0z'
    />
    <path fill='#fff' d='M18.5 11L9.9 1.5 7.1 4.6l-5.3 5.9-.4.5H0v1h19.8v-1h-1.3z' />
  </svg>
)

const SuggestionBox = forwardRef((props, ref) => {
  const [inputValue, setInputValue] = useState('')
  const [itemIsSelected, setItemIsSelected] = useState(false)
  let possibleMatches = []

  const onChange = e => {
    setItemIsSelected(false)
    setInputValue(e.target.value)
  }

  if (inputValue.length) {
    possibleMatches = suggestionData[props.suggestionData].filter(provider => {
      return provider.substr(0, inputValue.length).toLowerCase() === inputValue.toLowerCase()
    })
  }

  return (
    <Fragment>
      <div sx={{ variant: 'elements.simple-input.wrapper' }}>
        <label sx={{ display: 'block', mr: 'md', width: '100%' }}>
          <input
            type='input'
            name={props.name}
            placeholder={props.placeholder}
            onChange={onChange}
            ref={ref}
            sx={{ position: 'relative', variant: 'elements.simple-input.base' }}
            value={inputValue}
            autoComplete='off'
          />
        </label>
      </div>
      <div sx={{ display: possibleMatches.length ? 'block' : 'none' }}>
        <ul
          sx={{
            display: itemIsSelected ? 'none' : 'block',
            position: 'relative',
            border: '1px solid #B9B9BD',
            mt: 'sm',
            pl: 'sm',
            zIndex: '999',
            bg: 'white',
            color: 'black',
          }}
        >
          <p sx={{ fontWeight: '700', p: '0' }}>Your current provider</p>
          <div
            sx={{
              position: 'absolute',
              top: '-17px',
              zIndex: '1000',
            }}
          >
            {Triangle}
          </div>
          {possibleMatches.map(pm => (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
            <li
              sx={{ cursor: 'pointer', listStyle: 'none', lineHeight: 'md' }}
              onClick={() => {
                setItemIsSelected(true)
                setInputValue(pm)
              }}
              key={pm}
            >
              {pm}
            </li>
          ))}
        </ul>
      </div>
    </Fragment>
  )
})

export default SuggestionBox
